



















































































import Loader from '@/contexts/frontend/Loader.vue'

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String,
    userId: String
  },
  data: function() {
    return {
      user: {
        id: '',
        name: '',
        correlation: '',
        team: '',
        email: ''
      },
      loading: false,
      teams: []
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .GetUser(this.userId)
      .then(result => (this.user = result[0]))
      .then(() => this.$api.clientAdmin.ListTeams())
      .then(results => (this.teams = results))
      .finally(() => (this.loading = false))
  },
  methods: {
    saveUser() {
      this.$api.clientAdmin
        .UpdateUser(this.user)
        .then(() => this.$router.push({ name: 'settings-users-list' }))
    }
  }
}
